import script from "./CourseCertificateUploadModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CourseCertificateUploadModal.vue?vue&type=script&lang=ts&setup=true"

import "./CourseCertificateUploadModal.vue?vue&type=style&index=0&id=850ed452&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-850ed452"]])

export default __exports__